<template>
  <div id="apps">
    <BlocklyComponent
      id="blockly"
      :options="options"
      ref="foo"
    />
  </div>
</template>

<script setup>
import { ref } from "vue"
import BlocklyComponent from "./BlocklyComponent.vue"
import "@/libs/blockly/stocks"

import { pythonGenerator } from "blockly/python"

const foo = ref()
const code = ref()
const defineSetting = ref(`
    <xml>
      <category name="逻辑" colour="%{BKY_LOGIC_HUE}">
        <block type="controls_if"></block>
        <block type="logic_compare"></block>
        <block type="logic_operation"></block>
        <block type="logic_negate"></block>
        <block type="logic_boolean"></block>
      </category>
      <category name="循环" colour="%{BKY_LOOPS_HUE}">
        <block type="controls_repeat_ext">
          <value name="TIMES">
            <block type="math_number">
              <field name="NUM">10</field>
            </block>
          </value>
        </block>
        <block type="controls_whileUntil"></block>
      </category>
      <category name="数学" colour="%{BKY_MATH_HUE}">
        <block type="math_number">
          <field name="NUM">123</field>
        </block>
        <block type="math_arithmetic"></block>
        <block type="math_single"></block>
      </category>
      <category name="文本" colour="%{BKY_TEXTS_HUE}">
        <block type="text"></block>
        <block type="text_length"></block>
        <block type="text_print"></block>
      </category>
      <category name="变量" custom="VARIABLE" colour="%{BKY_VARIABLES_HUE}">
      </category>
    </xml>
  `)
// <category name="Stocks" colour="%{BKY_LOOPS_HUE}">
//   <block type="stock_buy_simple"></block>
//   <block type="stock_buy_prog"></block>
//   <block type="stock_fetch_price"></block>
// </category>

const options = {
  media: "/blockly/media/",
  grid: {
    spacing: 30,
    length: 6,
    colour: "#D9D9D9",
    snap: true,
  },
  toolbox: defineSetting.value,
  theme: {
    blockStyles: {
      logic_blocks: {
        colourPrimary: "%{BKY_LOGIC_HUE}",
      },
      math_blocks: {
        colourPrimary: "%{BKY_MATH_HUE}",
      },
      text_blocks: {
        colourPrimary: "%{BKY_TEXTS_HUE}",
      },
      variable_blocks: {
        colourPrimary: "%{BKY_VARIABLES_HUE}",
      },
      loop_blocks: {
        colourPrimary: "%{BKY_LOOPS_HUE}",
      },
      list_blocks: {
        colourPrimary: "%{BKY_LISTS_HUE}",
      },
    },
    componentStyles: {
      workspaceBackgroundColour: "#1e1e1e",
      toolboxBackgroundColour: "#333333",
      toolboxForegroundColour: "#ffffff",
    },
  },
}

const showCode = () =>
  (code.value = pythonGenerator.workspaceToCode(foo.value.workspace))
</script>

<style scoped>
#apps {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  width: 100%;
  height: 100%;
}

#blockly {
  position: relative;
  margin: 0;
  width: 100%;
  height: 100%;
  /* width: 1000px;
    height: 500px; */
}
</style>
